const install = (_, opts) => {
    if (!opts?.portalId)
        return;
    const hubspotScript = document.createElement("script");
    hubspotScript.id = "hs-script-loader";
    hubspotScript.async = true;
    hubspotScript.defer = true;
    hubspotScript.src = `//js.hs-scripts.com/${opts.portalId}.js`;
    document.head.append(hubspotScript);
};
const plugin = { install };
export default plugin;
//# sourceMappingURL=index.js.map